import { Linkable, LinkWrap } from "@/components/blocks/Linkable";
import { useLocalization } from "@/data/Localization";
import { useNavigation } from "@/data/Navigation";
import { SxProps } from '@mui/material';
import { Stack } from "@mui/system";
import { FC } from "react";
import { NavBarCategoriesMenu } from "./Menu/NavBarCategoriesMenu";

export const NavBarLeftLinks:FC<{sx?:SxProps}> = ({sx}) => {
    const HeaderLabels = useLocalization('Header');
    const { navigation } = useNavigation();
        const { AllCategoriesLabel } = useLocalization('AllCategoriesExpandedMenu');
        const filteredNavigation = navigation ? navigation.filter(obj =>{return obj.label===AllCategoriesLabel.t()}):undefined;
    return(
        <Stack component="nav" aria-label={'Menu navigatie'}>
            {filteredNavigation?.map(({ label, url, children }) => (
                <LinkWrap href={url} key={`${label}${url}`}>
                    <NavBarCategoriesMenu
                        tree={children}
                        label={label}
                        data-testid={`menu-item-${label}`}
                    />
                </LinkWrap>
            ))}
            <Linkable href={HeaderLabels.NavBar.ActiesLink.t()} role="link" aria-label={'Acties'}>{HeaderLabels.NavBar.Acties.t()}</Linkable>
            <Linkable href={HeaderLabels.NavBar.CadeausLink.t()} role="link" aria-label={'Cadeaus'}>{HeaderLabels.NavBar.Cadeaus.t()}</Linkable>
            <Linkable target="_blank" href={HeaderLabels.NavBar.KadokaartLink.t()} role="link" aria-label={'Kadokaart'}>{HeaderLabels.NavBar.Kadokaart.t()}</Linkable>
        </Stack>
    );
}